import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=8aebf9b2&scoped=true&lang=pug"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=8aebf9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aebf9b2",
  null
  
)

export default component.exports